import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { submitContactSupport } from "../thunks/contactSupport.thunk";
import {
  ContactSupportState,
  ContactSupportFormField,
  FieldErrors,
  INITIAL_CONTACT_SUPPORT_FORM,
} from "../interfaces/contactSupport.interface";

const initialState: ContactSupportState = {
  ...INITIAL_CONTACT_SUPPORT_FORM,
  isSubmitting: false,
  showConfirmation: false,
  errors: {},
  submitError: null,
};

const contactSupportSlice = createSlice({
  name: "contactSupport",
  initialState,
  reducers: {
    setField: (
      state,
      action: PayloadAction<{ field: ContactSupportFormField; value: string }>
    ) => {
      const { field, value } = action.payload;
      state[field] = value;
      if (state.errors[field]) {
        delete state.errors[field];
      }
    },
    setErrors: (state, action: PayloadAction<FieldErrors>) => {
      state.errors = action.payload;
    },
    clearSubmitError: (state) => {
      state.submitError = null;
    },
    closeConfirmation: (state) => {
      state.showConfirmation = false;
      state.submitError = null;
    },
    resetForm: (state) => {
      Object.assign(state, INITIAL_CONTACT_SUPPORT_FORM);
      state.errors = {};
      state.showConfirmation = false;
      state.submitError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitContactSupport.pending, (state) => {
        state.isSubmitting = true;
        state.submitError = null;
      })
      .addCase(submitContactSupport.fulfilled, (state) => {
        state.isSubmitting = false;
        state.showConfirmation = true;
        Object.assign(state, INITIAL_CONTACT_SUPPORT_FORM);
        state.errors = {};
        state.submitError = null;
      })
      .addCase(submitContactSupport.rejected, (state, action) => {
        state.isSubmitting = false;
        state.submitError =
          (action.payload as string) ||
          "We could not send your message. Please try again later.";
      });
  },
});

export const {
  setField,
  setErrors,
  clearSubmitError,
  closeConfirmation,
  resetForm,
} = contactSupportSlice.actions;

export default contactSupportSlice.reducer;
